module.exports = __webpack_public_path__ + "assets/img/mecha-btn-4b0d1e28.png";